'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.daysBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/daysBefore.js
// module id = 666
// module chunks = 0